import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../i18n/translations';
export function SkillsSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].skills;
  const skills = [{
    name: 'Unity',
    level: 85,
    color: '#00c9a7'
  }, {
    name: 'C#',
    level: 85,
    color: '#00c9a7'
  }, {
    name: 'Unreal Engine 5',
    level: 75,
    color: '#1a4fd6'
  }, {
    name: 'Blueprints',
    level: 75,
    color: '#1a4fd6'
  }, {
    name: 'C++',
    level: 70,
    color: '#1a4fd6'
  }, {
    name: 'Git / GitHub',
    level: 85,
    color: '#00f5a0'
  }];
  const badges = ['Agile/Scrum', 'Trello', 'Visual Studio', 'Miro', 'Figma', 'Hack n Plan', 'GitHub Desktop'];
  return <section id="skills" className="py-24 relative" data-id="element-247">
      <div className="max-w-7xl px-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="mb-16" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-250">{t.title}</h2>
          <div className="h-1 w-20 bg-gradient-to-r from-[#1a4fd6] to-[#00f5a0] rounded-full" data-id="element-251"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-252">
          {/* Skill Bars */}
          <div className="space-y-6" data-id="element-253">
            <h3 className="text-xl font-orbitron text-gray-300 mb-6" data-id="element-254">
              {t.core}
            </h3>
            {skills.map(skill => <div key={skill.name} className="space-y-2" data-id="element-255">
                <div className="flex justify-between text-sm font-medium" data-id="element-256">
                  <span data-id="element-257">{skill.name}</span>
                  <span className="text-gray-400" data-id="element-258">{skill.level}%</span>
                </div>
                <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden" data-id="element-259">
                  <div className="h-full rounded-full transition-all duration-1000 ease-out" style={{
                width: `${skill.level}%`,
                backgroundColor: skill.color,
                boxShadow: `0 0 10px ${skill.color}80`
              }} data-id="element-260"></div>
                </div>
              </div>)}
          </div>

          {/* Tools & Badges + Code Snippet */}
          <div className="flex flex-col" data-id="element-261">
            <h3 className="text-xl font-orbitron text-gray-300 mb-6" data-id="element-262">
              {t.tools}
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-263">
              {badges.map(badge => <span key={badge} className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-sm hover:border-#00f5a0/50 hover:bg-#00f5a0/10 transition-colors cursor-default" data-id="element-264">
                  {badge}
                </span>)}
            </div>

            <div className="mt-8 p-6 rounded-xl bg-gradient-to-br from-[#1a4fd6]/20 to-transparent border border-[#1a4fd6]/30" data-id="element-265">
              <h4 className="text-lg font-bold mb-2 text-white" data-id="element-266">
                {t.growing.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-267">{t.growing.description}</p>
            </div>

            {/* Code snippet — styled like other sections */}
            <div className="mt-6 p-5 rounded-xl border border-[#00f5a0]/20 bg-[#00f5a0]/5 backdrop-blur-sm" data-id="element-268">
              <p className="font-mono text-[#00f5a0] text-sm leading-relaxed" data-id="element-269">
                <span className="text-gray-500" data-id="element-270"> // runtime.log</span>
                <br data-id="element-271" />
                {'>'} skills.forEach(s {'=>'} s.Upgrade());
                <br data-id="element-272" />
                {'>'}{' '}
                <span className="text-white/50" data-id="element-273"> // never stop learning_</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}